import React, { Component } from 'react'

import withErrorBoundaryReturnNull from '../../../../../components/hocs/withErrorBoundaryReturnNull'
import InfoButton from '../../../../../components/ui/buttons/InfoButton'
import { yearRanges } from '../../../../../utils/string'
import numberConverter from '../../../../../utils/tuition/numberForCurrency'

import SalaryBarChart from './SalaryBarChart'

class AverageSalaryCardData extends Component {
  constructor(props) {
    super(props)

    this.averageSalary = 51000

    this.salaryInsight = () => {
      if (this.props.predictedSalary > this.averageSalary * 1.4) {
        return 'is significantly higher than'
      } else if (this.props.predictedSalary > this.averageSalary * 1.2) {
        return 'is higher than'
      } else if (this.props.predictedSalary > this.averageSalary * 1.2) {
        return 'is higher than'
      } else if (this.props.predictedSalary > this.averageSalary) {
        return 'is slightly higher than'
      } else if (this.props.predictedSalary > this.averageSalary * 0.8) {
        return 'is slightly lower than'
      } else if (this.props.predictedSalary <= this.averageSalary * 0.8) {
        return 'is lower than'
      } else {
        return 'error'
      }
    }
  }
  render() {
    const {
      predictedSalary,
      salaryDistribution,
      yearsToPosition,
      categoryData: { category, jobs2016, employmentGrowth },
      isMobile,
    } = this.props

    return (
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <div className="row" style={{ marginTop: isMobile ? 0 : 20 }}>
          <div className="col-md-6 text-center">
            <div className="mt-3">
              The salary for this job {this.salaryInsight()} the national average of $
              {numberConverter(this.averageSalary)}.
            </div>
            <div className="max-400">
              <SalaryBarChart salaryDistribution={salaryDistribution} />
            </div>
            <h2 className="text-center color-green mb-0" style={{ fontSize: 35 }}>
              <sup className="text-muted" style={{ fontSize: 20 }}>
                $
              </sup>
              {numberConverter(predictedSalary)}
            </h2>
            <p style={{ color: 'white', marginBottom: 0 }}>{category}</p>
          </div>

          {!isMobile && (
            <div
              className="col-md-6 text-center"
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}
            >
              {!!yearsToPosition && (
                <div>
                  <h5 className="data-title mt-1">Average Years to Reach</h5>
                  <h5 className="data-number">{`${yearRanges(yearsToPosition)} years`}</h5>
                  <InfoButton
                    content="The average amount of experience of people in this dataset."
                    styles={{ paddingTop: 0, color: '#686c6f' }}
                  />
                  <br />
                </div>
              )}
              {jobs2016 && !yearsToPosition && (
                <div>
                  <h5 className="data-title mt-1">2016 - People in the Field</h5>
                  <h5 className="data-number">{numberConverter(jobs2016 * 1000)}</h5>
                  <InfoButton
                    content="The number of people working in the industry right now."
                    styles={{ paddingTop: 0, color: '#686c6f' }}
                  />
                  <br />
                </div>
              )}
              {employmentGrowth && (
                <div>
                  <h5 className="data-title">2026 - Projected Industry Growth</h5>
                  <h5 className="data-number">
                    {Math.round(employmentGrowth * 10) / 10}
                    <sup>%</sup>
                  </h5>
                  <InfoButton
                    content="The Bureau of Labor Statistics projects industry growth in 10 years. The average is 7.4 percent growth."
                    styles={{ paddingTop: 0, color: '#686c6f' }}
                  />
                  <br />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default withErrorBoundaryReturnNull(AverageSalaryCardData)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/AverageSalaryCardData.js